import { ITelemetryItem } from '@microsoft/applicationinsights-web';

export function filterTelemetry(item: ITelemetryItem): boolean | void {
  switch (item.baseType) {
    case 'ExceptionData': {
      const message = Array.isArray(item.baseData?.exceptions)
        ? item.baseData?.exceptions[0]?.message
        : (item.baseData?.message as string | null);
      if (
        message?.startsWith('Http failure response') &&
        (message?.includes('400') || message?.includes('401') || message?.includes('404')) &&
        item.baseData
      ) {
        item.baseData.severityLevel = 1;
      }
      if (message?.endsWith("'window.webkit.messageHandlers')") && item.baseData) {
        item.baseData.severityLevel = 1;
      }
      if (message?.startsWith("null is not an object (evaluating 'n.title')") && item.baseData) {
        item.baseData.severityLevel = 1;
      }
      if (message?.endsWith("'window.webkit.messageHandlers.selectedTextHandler.postMessage')") && item.baseData) {
        item.baseData.severityLevel = 1;
      }
      if (message?.endsWith("Consider using the 'crossorigin' attribute.") && item.baseData) {
        item.baseData.severityLevel = 2;
      }
      if (message?.includes("undefined is not an object (evaluating 'navigator.languages.filter')") && item.baseData) {
        item.baseData.severityLevel = 2;
      }
      const topStackMethod =
        Array.isArray(item.baseData?.exceptions) && Array.isArray(item.baseData?.exceptions[0]?.parsedStack)
          ? item.baseData?.exceptions[0]?.parsedStack[0]?.method
          : (null as string | null);
      if (topStackMethod?.includes('_trySubscribe') && item.baseData) {
        item.baseData.severityLevel = 2;
      }
      return true;
    }
    default:
      break;
  }
  return true;
}
